<template>
  <div class="user-content-section">
    <div class="page-sub-title user-sub-title">
      <h2>
        <i class="fa-title"></i>
        <div>{{ $t("promo_codes") }}</div>
      </h2>
    </div>

    <div class="cart-login">
      <div class="social-row">
        <div class="cart-social-ref">
          <form
            class="user-form user-form-password"
            @submit.prevent="activatePromoCode"
          >
            <div class="user-form-group">
              <input
                :class="{
                  invalid:
                    (!$v.code.required && $v.code.$dirty) ||
                    (!$v.code.minLength && $v.code.$dirty) ||
                    (!$v.code.maxLength && $v.code.$dirty),
                }"
                type="text"
                v-model="code"
                class="user-profile-input"
                :placeholder="$t('code_placeholder')"
              />
              <div class="error" v-if="!$v.code.required && $v.code.$dirty">
                <div>{{ $t("enter_promo_code") }}</div>
              </div>
              <div
                class="error"
                v-if="
                  (!$v.code.minLength && $v.code.$dirty) ||
                  (!$v.code.maxLength && $v.code.$dirty)
                "
              >
                <div>{{ $t("promo_code_length_error") }}</div>
              </div>
            </div>

            <label class="user-sub">
              <input type="submit" />
              <div>{{ $t("enter") }}</div>
            </label>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { minLength, maxLength, required } from "vuelidate/lib/validators";

export default {
  title: "Promo kodlari",
  async beforeCreate() {
    await this.$store.dispatch("getCertificates");
  },
  data() {
    return {
      code: "",
    };
  },
  methods: {
    async activatePromoCode() {
      this.$v.code.$touch();
      if (this.$v.code.$invalid) {
        return;
      }
      let data = {
        code: this.code,
      };

      await this.$store.dispatch("activatePromoCode", data);

      this.$v.$reset();
      this.code = "";
    },
  },
  validations: {
    code: {
      required,
      minLength: minLength(6),
      maxLength: maxLength(8),
    },
  },
  components: {},
};
</script>
